import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Email from "@material-ui/icons/Email";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
  TextField,
  Select,
  FormControl,
  Grid,
  Typography,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import styles from "./styles";

const Field = ({
  classes,
  type,
  name,
  formik,
  label,
  typeField,
  options,
  dataOptions,
  inputLabel,
  date,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const error =
    formik.errors[name] && (formik.touched[name] || formik.values[name].length);

  const [age, setAge] = React.useState("");

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  if (date) {
    /*<MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Dia"
            value={formik.values[name]}
            onChange={formik.handleChange(name)}
          />
        </Grid>
      </MuiPickersUtilsProvider>*/
  }

  if (options) {
    return (
      <FormControl className={classes.textField}>
        <InputLabel id="demo-simple-select-label">{inputLabel}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={formik.values[name]}
          onChange={formik.handleChange(name)}
        >
          {dataOptions.map((item) =>
            item.department_id ? (
              <MenuItem value={item.sub_id}>
                {item.department_name + " " + ">>" + " " + item.name}
              </MenuItem>
              ) : item.report_id ? (
                <MenuItem value={item.id}>{item.description}</MenuItem>
            ) : (
              <MenuItem value={item.id}>{item.name}</MenuItem>
            )
          )}
        </Select>
      </FormControl>
    );
  }
  if (type === "password") {
    return (
      <Grid container>
        <Grid item>
          <TextField
            style={{ minWidth: 180 }}
            className={classes.textField}
            label={label ? label : "Senha"}
            variant="filled"
            id={formik.values[name]}
            value={formik.values[name]}
            onChange={formik.handleChange(name)}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Typography className={classes.errorText}>
          {error ? formik.errors[name] : ""}
        </Typography>
      </Grid>
    );
  }

  if (type === "email") {
    return (
      <>
        <Grid item>
          <TextField
            className={classes.textField}
            label="E-mail"
            variant="filled"
            id={formik.values[name]}
            value={formik.values[name]}
            onChange={formik.handleChange(name)}
            type="email"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton disabled>
                    <Email />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Typography className={classes.errorText}>
          {error ? formik.errors[name] : ""}
        </Typography>
      </>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          className={classes.textField}
          label={label}
          id={formik.values[name]}
          value={formik.values[name]}
          onChange={formik.handleChange(name)}
          type={typeField}
        />
      </Grid>
      <Typography className={classes.errorText}>
        {error ? formik.errors[name] : ""}
      </Typography>
    </Grid>
  );
};

export default withStyles(styles)(Field);
